// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../public/SiteIcons/paginationRightArrow.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../public/SiteIcons/paginationLeftArrow.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customPaginationContainer {
    margin-top: 24px;
    margin-bottom: 24px;
    text-align: center;
    position: relative;
}

.rc-pagination {
    font-family: var(--font-family-base);
    list-style-type: none;
    padding-bottom: 50px;
    gap: 8px;
    grid-gap: 8px;
    flex-wrap: wrap;
}

.rc-pagination-total-text {
    position: absolute;
    bottom: 10px;
    left: 0px;
    right: 0px;
    color: var(--common-text-color);
    font-size: 14px;
    font-weight: 500;
    margin: 0;
}

.rc-pagination-item {
    background-color: var(--primary-white-bg);
}

.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next,
.rc-pagination-item,
.rc-pagination-next {
    margin-right: 0;
    font-family: var(--font-family-base);
    border-radius: var(--border-radius-1);
}

.rc-pagination-item a,
.rc-pagination-prev span,
.rc-pagination-next span,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
    color: var(--common-text-color);
}

.rc-pagination-item:hover,
.rc-pagination-item:focus {
    border-color: var(--common-link-color);
}

.rc-pagination-item:hover a,
.rc-pagination-item:focus a {
    color: var(--common-text-color);
}

.rc-pagination-item-active,
.rc-pagination-item-active:hover,
.rc-pagination-item-active:focus {
    background-color: var(--common-link-color);
    border-color: var(--common-link-color);
}

.rc-pagination-item-active a,
.rc-pagination-item-active:hover a,
.rc-pagination-item-active:focus a {
    color: var(--white-text);
}

.rc-pagination-prev,
.rc-pagination-next {
    border: 1px solid var(--primary-border);
    font-size: 18px;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,
.rc-pagination-jump-next .rc-pagination-jump-custom-icon {
    position: relative;
    top: -1px;
}

.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,
.rc-pagination-jump-next .rc-pagination-jump-custom-icon {
    font-size: 12px;
}

.rc-pagination-jump-afterHover-icon {
    display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {
    display: none;
}

.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,
.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {
    display: inline-block;
    color: var(--pagination-icon-hover-bg);
}

.rc-pagination-navigation-icon {
    width: 12px;
    height: 12px;
}

.rc-pagination-next .rc-pagination-navigation-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-size: contain;
    background-position: center;
}

.rc-pagination-prev .rc-pagination-navigation-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    background-size: contain;
    background-position: center;
}

.rc-pagination-options {
    display: none;
}

/* rtl */

.rtl .rc-pagination-navigation-icon {
    transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/styles/customPagination.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;IACpB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;;;;IAKI,eAAe;IACf,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;;;;;IAKI,+BAA+B;AACnC;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;;IAGI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;;IAEI,uCAAuC;IACvC,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6DAA4E;IAC5E,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,6DAA2E;IAC3E,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA,QAAQ;;AAER;IACI,yBAAyB;AAC7B","sourcesContent":[".customPaginationContainer {\n    margin-top: 24px;\n    margin-bottom: 24px;\n    text-align: center;\n    position: relative;\n}\n\n.rc-pagination {\n    font-family: var(--font-family-base);\n    list-style-type: none;\n    padding-bottom: 50px;\n    gap: 8px;\n    grid-gap: 8px;\n    flex-wrap: wrap;\n}\n\n.rc-pagination-total-text {\n    position: absolute;\n    bottom: 10px;\n    left: 0px;\n    right: 0px;\n    color: var(--common-text-color);\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.rc-pagination-item {\n    background-color: var(--primary-white-bg);\n}\n\n.rc-pagination-prev,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next,\n.rc-pagination-item,\n.rc-pagination-next {\n    margin-right: 0;\n    font-family: var(--font-family-base);\n    border-radius: var(--border-radius-1);\n}\n\n.rc-pagination-item a,\n.rc-pagination-prev span,\n.rc-pagination-next span,\n.rc-pagination-jump-prev,\n.rc-pagination-jump-next {\n    color: var(--common-text-color);\n}\n\n.rc-pagination-item:hover,\n.rc-pagination-item:focus {\n    border-color: var(--common-link-color);\n}\n\n.rc-pagination-item:hover a,\n.rc-pagination-item:focus a {\n    color: var(--common-text-color);\n}\n\n.rc-pagination-item-active,\n.rc-pagination-item-active:hover,\n.rc-pagination-item-active:focus {\n    background-color: var(--common-link-color);\n    border-color: var(--common-link-color);\n}\n\n.rc-pagination-item-active a,\n.rc-pagination-item-active:hover a,\n.rc-pagination-item-active:focus a {\n    color: var(--white-text);\n}\n\n.rc-pagination-prev,\n.rc-pagination-next {\n    border: 1px solid var(--primary-border);\n    font-size: 18px;\n    line-height: normal;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,\n.rc-pagination-jump-next .rc-pagination-jump-custom-icon {\n    position: relative;\n    top: -1px;\n}\n\n.rc-pagination-jump-prev .rc-pagination-jump-custom-icon,\n.rc-pagination-jump-next .rc-pagination-jump-custom-icon {\n    font-size: 12px;\n}\n\n.rc-pagination-jump-afterHover-icon {\n    display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-beforeHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-beforeHover-icon {\n    display: none;\n}\n\n.rc-pagination-jump-prev:hover .rc-pagination-jump-afterHover-icon,\n.rc-pagination-jump-next:hover .rc-pagination-jump-afterHover-icon {\n    display: inline-block;\n    color: var(--pagination-icon-hover-bg);\n}\n\n.rc-pagination-navigation-icon {\n    width: 12px;\n    height: 12px;\n}\n\n.rc-pagination-next .rc-pagination-navigation-icon {\n    background: url('../../public/SiteIcons/paginationRightArrow.svg') no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.rc-pagination-prev .rc-pagination-navigation-icon {\n    background: url('../../public/SiteIcons/paginationLeftArrow.svg') no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.rc-pagination-options {\n    display: none;\n}\n\n/* rtl */\n\n.rtl .rc-pagination-navigation-icon {\n    transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
